<div class="container-fluid">
    <div class="row">
        <app-wanderplan-card
        class = "col-lg-4 col-sm-12 mb-3"
        *ngFor="let card of wanderplanCards"
        [data] = card
        ></app-wanderplan-card>
    </div>
</div>